/* eslint-disable max-classes-per-file */
import { Type } from 'class-transformer';
import { ProductTypes, BasketItemModel, BasketPriceModel, BasketAddressModel } from 'models/Basket';

export class PlacedOrderModel {
    public code: string;
    public placed: string;
    public guid: string;

    public placementStore: string;

    @Type(() => BasketItemModel)
    public entries: BasketItemModel[] = [];

    public eca: number | null = null;
    public leadTime: number | null = null;

    @Type(() => BasketPriceModel)
    public deliveryCost: BasketPriceModel;

    @Type(() => BasketPriceModel)
    public totalPriceWithTax: BasketPriceModel;

    @Type(() => BasketPriceModel)
    public totalTax: BasketPriceModel;

    @Type(() => BasketPriceModel)
    public totalDiscounts: BasketPriceModel | null = null;

    @Type(() => OrderUser)
    public user: OrderUser | null = null;

    @Type(() => BasketAddressModel)
    public deliveryAddress: BasketAddressModel;

    public hasDonationProduct(): boolean {
        return this.entries.some((basketItem: BasketItemModel) => basketItem.product.type === ProductTypes.Donation);
    }

    public hasQuickstockItem(): boolean {
        return this.entries.some((basketItem: BasketItemModel) => basketItem.isQuickstock());
    }
}

class OrderUser {
    name: string;
    uid: string;
}